import React from "react";
import { Box, Alert, AlertTitle, Button } from "@mui/material";
import { Info, Close } from "@mui/icons-material";

const NoticeBanner = ({ notice, onDismiss }) => {
  // For mailto links, use anchor tag directly
  // For other links, use button with onClick
  const isMailto = notice.buttonAction && notice.buttonAction.startsWith("mailto:");
  
  const handleButtonClick = (e) => {
    if (notice.buttonAction) {
      if (isMailto) {
        // For mailto links, use window.location.href
        // This is the most reliable way to trigger mailto links
        window.location.href = notice.buttonAction;
      } else {
        window.open(notice.buttonAction, "_blank");
      }
    }
  };

  return (
    <Box sx={{ marginBottom: 2, marginTop: 2 }}>
      <Alert
        severity="info"
        icon={<Info />}
        action={
          onDismiss && (
            <Button
              color="inherit"
              size="small"
              onClick={onDismiss}
              sx={{ minWidth: "auto" }}
            >
              <Close fontSize="small" />
            </Button>
          )
        }
        sx={{
          "& .MuiAlert-message": {
            width: "100%",
          },
        }}
      >
        <AlertTitle sx={{ fontWeight: "bold", marginBottom: 1 }}>
          {notice.heading}
        </AlertTitle>
        <Box sx={{ marginBottom: notice.buttonText ? 1 : 0 }}>
          {notice.description}
        </Box>
        {notice.buttonText && (
          isMailto ? (
            <Box
              component="a"
              href={notice.buttonAction}
              sx={{
                marginTop: 1,
                display: "inline-block",
                textDecoration: "none",
              }}
            >
              <Button
                variant="contained"
                color="primary"
                size="small"
                component="span"
              >
                {notice.buttonText}
              </Button>
            </Box>
          ) : (
            <Button
              variant="contained"
              color="primary"
              size="small"
              onClick={handleButtonClick}
              sx={{ marginTop: 1 }}
            >
              {notice.buttonText}
            </Button>
          )
        )}
      </Alert>
    </Box>
  );
};

export default NoticeBanner;

